{
  "close": "Cerrar",
  "notifications": "{count, plural, one {# notificación} other {# notificaciones}}."
}
